import { Modal, Space, Typography } from 'antd';
import Button from '../../UI/Button/Button';
import React from 'react';
import Input from '../../UI/Input/Input';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const ConfirmEmailModal = ({
  open,
  onClose,
  onSubmit,
  onChange,
  onHome,
  code,
  loading,
  onResend
}) => {
  const { t } = useTranslation();

  const handleSubmit = () => {
    onSubmit();
  };

  const handleClose = () => {
    onClose();
  };

  const handleHome = () => {
    onHome();
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={handleClose}
    >
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 1000
          }}
        >
          <Spin
            indicator={<LoadingOutlined spin />}
            style={{ height: 'fit-content' }}
          />
        </div>
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          alignItems: 'center',
          marginTop: 50,
          width: '100%'
        }}
      >
        <h2 style={{ textAlign: 'center' }}>Confirm email</h2>
        <Typography
          style={{
            marginTop: 20,
            marginBottom: 20,
            fontSize: 20,
            fontWeight: 400,
            textAlign: 'center'
          }}
        >
          We have sent verification code to your email. Please enter it below:
        </Typography>
        <Input
          value={code}
          onChange={(e) => onChange(e.target.value)}
          placeholder={'Code'}
        />
        <Space
          size={10}
          style={{ marginTop: 20, width: '100%' }}
          direction='vertical'
        >
          <Button disabled={!code} wide onClick={handleSubmit}>
            Confirm
          </Button>
          <Button
            wide
            mode="outlined"
            onClick={onResend}
            style={{ marginTop: 10 }}
          >
            {t('pages.auth.codeResent.button')}
          </Button>
          <Button wide mode='outlined' onClick={handleHome}>
            {t('button.home')}
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default ConfirmEmailModal;
